import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const DECIMALS = 3;

export interface IRatiosTableRow {
  month: string,
  handling_per_income: number,
  transport_per_income: number,
  receiving_per_income: number,
  recycling_per_cost: number,
  recycling_per_income: number,
  refund_per_income: number,
  cost_per_income: number,
  handling: number,
  transport: number,
  receiving: number,
  containers: number,
  cost: number,
  metal_refund: number,
  recycling_fee: number,
  income: number,
  totals?: boolean
}

export interface IRatiosTableProps {
  header: string;
  data: IRatiosTableRow[];
}

const COLUMNS = [
  'month',
  'handling_per_income',
  'transport_per_income',
  'receiving_per_income',
  'recycling_per_cost',
  'recycling_per_income',
  'refund_per_income',
  'cost_per_income',
  'handling',
  'transport',
  'receiving',
  'containers',
  'cost',
  'metal_refunds',
  'recycle_fees',
  'income'
];

const RatiosTable: React.FunctionComponent<IRatiosTableProps> = (props: IRatiosTableProps) => {
  const [ratios, setRatios] = useState([] as IRatiosTableRow[]);

  useEffect(() => {
    setRatios(props.data);
  }, [props.data, props.header]);


  const getTableRange = () => {
    const range: JSX.Element[] = [];
    range.push(<th className="empty" key={"empty"}></th>);
    range.push(<th colSpan={7} className="report-compare range-header" key={"report-compare-range"}>{props.header}</th>);
    return range;
  }

  const getTableHeaders = () => {
    const headers: JSX.Element[] = [];
    COLUMNS.forEach((name) => {
      const classes = ['header'];
      headers.push(
        <th key={name}>
          <span className={classes.join(' ')}>
            <FormattedMessage id={`comparereport.datatable.${name}`}/>
          </span>
        </th>
      );
    });
    return headers;
  }

  const getDataTable = ( ) => {
    const options: { }[] = [];
    if (ratios && Array.isArray(ratios)) {
      for(let index = 0; index < ratios.length; index++) {
        let classTmp = ratios[index].totals ? 'totals' : '';
        options.push(
          <tr key={index} className={classTmp}>
            {firstCell(ratios[index])}
            <td className="right">
              <FormattedNumber value={ratios[index].handling_per_income} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].transport_per_income} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].receiving_per_income} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].recycling_per_cost} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].recycling_per_income} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].refund_per_income} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/>
            </td>
            <td className="right divider">
              <FormattedNumber value={ratios[index].cost_per_income} maximumFractionDigits={DECIMALS} minimumFractionDigits={DECIMALS}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].handling} maximumFractionDigits={0} minimumFractionDigits={0}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].transport} maximumFractionDigits={0} minimumFractionDigits={0}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].receiving} maximumFractionDigits={0} minimumFractionDigits={0}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].containers} maximumFractionDigits={0} minimumFractionDigits={0}/>
            </td>
            <td className="right sum divider">
              <FormattedNumber value={ratios[index].cost} maximumFractionDigits={0} minimumFractionDigits={0}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].metal_refund} maximumFractionDigits={0} minimumFractionDigits={0}/>
            </td>
            <td className="right">
              <FormattedNumber value={ratios[index].recycling_fee} maximumFractionDigits={0} minimumFractionDigits={0}/>
            </td>
            <td className="right sum divider">
              <FormattedNumber value={ratios[index].income} maximumFractionDigits={0} minimumFractionDigits={0}/>
            </td>
          </tr>
        );
      }
    }
    return options;
  }

  const firstCell = (row: IRatiosTableRow) => {
    if (row.totals) {
      return <td className="right divider" ><FormattedMessage id={`summaryreport.browse.datatable.totals`}/></td>
    } else {
      return  <td className="right divider" >{row ? row.month : ""}</td>;
    }
  }

  return (
    <div className="CompareReportTable">
      <div className="table-responsive">
        <Table className="table table-sm">
          <thead className="reportDataHeader table">
          <tr>
            { getTableRange() }
          </tr>
          <tr className="table-headers">
            { getTableHeaders() }
          </tr>
          </thead>
          <tbody className="reportData table table-bordered">
            { getDataTable() }
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default RatiosTable;
